export const setItem = (cname, cvalue, exdays = 0, exMinutes = 0) => {
    const d = new Date()
    let secureStr = ""
    if (location.protocol === "https:") {
        secureStr = ";secure"
    }
    if (exdays) {
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
        const expires = 'expires=' + d.toUTCString()
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/' + secureStr
    } else if (exMinutes) {
        d.setTime(d.getTime() + (exMinutes * 60 * 1000))
        const expires = 'expires=' + d.toUTCString()
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/' + secureStr
    } else {
        document.cookie = cname + '=' + cvalue + ';path=/' + secureStr
    }
}

export const getItem = (cname) => {
    const name = cname + '='
    const ca = document.cookie.split(';')
    for (let c of ca) {
        while (c.charAt(0) === ' ') {
            c = c.substring(1)
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length)
        }
    }
    return ''
}

export const removeItem = (cname) => {
    document.cookie = cname + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/'
}

export const clear = () => {
    const cookies = document.cookie.split(';')

    for (const cookie of cookies) {
        const eqPos = cookie.indexOf('=')
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/'
    }
}

export default {
    setItem,
    getItem,
    removeItem,
    clear
}
